<template
  src="./index.html"
  lang="html"
/>
<style
  src="../../stylus/main.css"
  lang="css">
</style>
<script>
    import prvMultiSelect from "../../components/prv-multi-select/prv-multi-select.vue";
    import prvButtonLoader from '../../components/prv-button-loader/prv-button-loader.vue';
    import prvInput from '../../components/prv-input/prv-input.vue';
    import prvTooltip from '../../components/prv-tooltip/prv-tooltip.vue';
    import prvEmptyList from '../../components/prv-empty-list/prv-empty-list.vue';
    import prvTreeView from "../../components/prv-tree-view/prv-tree-view.vue";
    export default {
        components: {
            'prv-multi-select': prvMultiSelect,
            'prv-button-loader': prvButtonLoader,
            'prv-input': prvInput,
            'prv-tooltip': prvTooltip,
            'prv-empty-list': prvEmptyList,
            'prv-tree-view': prvTreeView,
        },
        props:{            
            isEdited: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                chapter: '',
                concept: '',
                category: '', 
                search: '',
                items: [],
                LABEL_TAGS: {
                    CHAPTER: "Chapter",
                    CONCEPT: "Concept",
                    CATEGORY: "Category",
                },    
                savedItems: [],
                tags: [],
                ORIGIN_SIGN_UP: 'NEC19'
            }
        },
        computed: {
            chaptersComputed () {
            return [...new Set(this.items.map(prod => prod.chapter))]
            },
            conceptsComputed () {
            return [...new Set(this.items.map(prod => prod.concept))]
            },
            categorysComputed () {
            return [...new Set(this.items.map(prod => prod.category))]
            },
            filteredItems () {
            return this.items.filter(prod => {
                let filterChapter = this.chapter ? prod.chapter === this.chapter : true
                let filterConcept = this.concept ? prod.concept === this.concept : true
                let filterCategory = this.category ? prod.category === this.category : true
                let filterDenomination = 
                            this.search ? prod.denomination.toLowerCase().includes(this.search.toLowerCase()) 
                                        : true
                return filterChapter && filterConcept && filterCategory && filterDenomination
            })
            },
        },
        created () {
            fetch('/api/v1/signup/monterrey-catalogs/', {
                method: 'GET',
                headers: {'x-origin': this.ORIGIN_SIGN_UP }
                })
                .then(response => response.json()) 
                .then(data => {
                    this.items = data; 
                })
                .catch(err => {
                    console.error(err);
                })
        }, 
        methods:{
            filteredProductsAndServices () {
              const save =  this.savedItems.map(prod => {
                    return {
                        id: prod.id,
                        denomination: prod.denomination,
                    }
                })
                this.$emit('savelist', save)
               return save
            }, 
            selectItem(savedItemId) {
                const isIncluded = this.savedItems.some(item => savedItemId === item.id);

                if (!isIncluded) {
                    const  newItem = this.items.filter(item => item.id === savedItemId);
                    this.savedItems.push(newItem[0]); 
                }   
                this.filteredProductsAndServices()
            },
            deleteItem(index) {
                this.savedItems.splice(index, 1);
            },
            deleteTagChapter() {
                this.chapter = '';
            },
            deleteTagConcept() {
                this.concept = '';
            },
            deleteTagCategory() {
                this.category = '';
            },
        },
    }
</script>       